/**
 * Shop All Side Menu
 */
(() => {
  /**
   * Logo
   */
  document.querySelector('.verticalmenu nav').prepend(
    document.querySelector('.logo').cloneNode(true),
  );

  /**
   * Tier 2 Sidebar
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children .cd-secondary-dropdown').forEach((sidemenu) => {
    sidemenu.querySelector('.go-back').remove(); // remove back button

    sidemenu.innerHTML = `
      <div class="nLeft">
        <a class="secondary-title" href="${sidemenu.parentNode.querySelector('a').getAttribute('href')}">${sidemenu.parentNode.querySelector('a').innerHTML}</a>
        <div class="item-bubbles">
          <div class="main-bubble nActive"><img class="bubble-item" src="${sidemenu.querySelector('.has-image img').getAttribute('src')}" alt=""></div>
          <div class="sub-bubbles bub-1"></div>
          <div class="sub-bubbles bub-2"></div>
          <div class="sub-bubbles bub-3"></div>
        </div>
        <div class="nBottom">
          ${sidemenu.innerHTML}
        </div>
      </div>
    `;

    const cloneTitle = sidemenu.querySelector('.nLeft > a').cloneNode(true);
    cloneTitle.innerHTML = `View All <span>${cloneTitle.innerHTML}</span>`;
    sidemenu.querySelector('.nLeft').append(cloneTitle);

    // Search box
    sidemenu.querySelector('.sideimage')?.remove();

    // Close button
    let close = document.createElement('div');
    close.innerHTML = '<a class="close-button">x</a>';
    close = close.firstElementChild;
    close.setAttribute('href', '#');
    close.addEventListener('click', () => {
      sidemenu.parentNode.classList.remove('active');
    });
    sidemenu.querySelector('.nLeft').prepend(close);
  });

  // Add Background Tier 2
  const tierTwo = document.querySelectorAll('.verticalmenu .nLeft');
  tierTwo.forEach((item) => {
    const background = document.createElement('div');
    background.classList.add('background-image');
    const bgImg = item.querySelector('.nBottom .bg-img img').getAttribute('src');
    background.style.backgroundImage = `url(${bgImg})`;
    item.prepend(background);
  });

  /**
   * Item Bubbles
   */
  // (() => {
  //   const query = document.querySelector('.verticalmenu nav');
  //   if (!query) return;

  //   // hover item to switch main bubble
  //   const Secondarymenu = query.querySelectorAll('.cd-secondary-dropdown');
  //   Secondarymenu.forEach((menu) => {
  //     const mainBubble = menu.querySelector('.bubble-item');
  //     const items = menu.querySelectorAll('.nBottom > li > a');
  //     items.forEach((item) => {
  //       item.addEventListener('mouseover', () => {
  //         mainBubble.parentNode.classList.remove('nActive');
  //         setTimeout(() => {
  //           const bubbleImage = item.parentNode.querySelector('img');
  //           if (!bubbleImage) return;
  //           mainBubble.setAttribute('src', bubbleImage.getAttribute('src'));
  //           mainBubble.parentNode.classList.add('nActive');
  //         }, 500);
  //       });
  //     });
  //   });
  // })();

  /**
   * Tier 1
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children > a').forEach((item) => {
    item.removeAttribute('href');
    item.innerHTML = `
      <div class="background"></div>
      <p>${item.innerHTML}</p>
    `;

    // Handle On-click
    item.addEventListener('click', (e) => {
      document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
        if (itemmenu === e.currentTarget.parentNode) return;
        itemmenu.classList.remove('active');
      });
      e.currentTarget.parentNode.classList.toggle('active');
    });
  });

  // Login & Signup
  (() => {
    const loginButton = document.querySelector('.shoppingtools_container').cloneNode(true);
    document.querySelector('.verticalmenu nav').appendChild(loginButton);
  })();

  // Contact Us
  (() => {
    const contactButton = document.createElement('div');
    contactButton.classList.add('contact-us');
    contactButton.innerHTML = /* html */`
      <i class="fas fa-phone-alt" aria-hidden="true"></i>
      <a href="#" id="myContactModalButton" class="contact-link">Contact Us</a>
      `;
    document.querySelector('.verticalmenu nav').appendChild(contactButton);
  })();

  // Close button
  let close = document.createElement('div');
  close.innerHTML = '<a class="close-button">x</a>';
  close = close.firstElementChild;
  close.setAttribute('href', '#');
  close.addEventListener('click', () => {
    document.querySelector('body').click();

    document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
      itemmenu.classList.remove('active');
    });
  });
  document.querySelector('.cd-dropdown').prepend(close);
})();

/**
 * Change mobile so that it doesn't go through to Tier 3 which is just an image
 */
(() => {
  const headerMobile = document.querySelector('.header-mobile .header-menu');
  if (!headerMobile) return;
  const removeTier3 = () => {
    const goBack = document.querySelector('#mobileVueNav .go-back-mobile');
    if (!goBack.classList.contains('hide')) {
      const tierTwos = document.querySelectorAll('#mobileVueNav li:not(.go-back-mobile)');
      tierTwos.forEach((tierTwo) => {
        const anchor = tierTwo.querySelector('a');
        anchor.classList.remove('has-children');
        const clone = anchor.cloneNode(true);
        clone.classList.add('tier-two');
        tierTwo.appendChild(clone);
        anchor.classList.add('hide');
      });
    }
  };

  removeTier3();

  const addEventListeners = () => {
    const tierTwos = document.querySelectorAll('#mobileVueNav li:not(.go-back-mobile) a');
    const goBack = document.querySelector('#mobileVueNav .go-back-mobile');

    tierTwos.forEach((tierTwo) => {
      tierTwo.addEventListener('click', removeTier3);
    });

    if (goBack) {
      goBack.addEventListener('click', removeTier3);
    }
  };

  addEventListeners();

  const observer = new MutationObserver(() => {
    addEventListeners();
  });

  observer.observe(document.querySelector('#mobileVueNav'), { childList: true, subtree: true });
})();
